// extracted by mini-css-extract-plugin
export var postExcerpt__content = "index-module--post-excerpt__content--78477";
export var postExcerpt__info = "index-module--post-excerpt__info--f519a";
export var postExcerpt__keyword = "index-module--post-excerpt__keyword--a0c11";
export var postExcerpt__title = "index-module--post-excerpt__title--fd1d0";
export var postExcerpt__wrapper = "index-module--post-excerpt__wrapper--e5c60";